var map = {
	"./logo-akt.svg": 20143,
	"./logo-alter.svg": 98572,
	"./logo-amatom.svg": 17834,
	"./logo-amparch.svg": 82065,
	"./logo-andr.svg": 27507,
	"./logo-arch.svg": 53024,
	"./logo-astro.svg": 84021,
	"./logo-atom.axv.svg": 44215,
	"./logo-atom.svg": 61388,
	"./logo-ausd.svg": 33627,
	"./logo-axl.svg": 84563,
	"./logo-axv.svg": 69263,
	"./logo-bcna.svg": 47929,
	"./logo-bld.svg": 80394,
	"./logo-bnusd.svg": 85104,
	"./logo-btsg.svg": 97281,
	"./logo-busd.axv.svg": 38225,
	"./logo-busd.svg": 97946,
	"./logo-cmdx.svg": 65253,
	"./logo-const.svg": 33790,
	"./logo-core.svg": 72341,
	"./logo-cronos.svg": 86715,
	"./logo-cudos.svg": 90819,
	"./logo-dec.svg": 38418,
	"./logo-dgn.svg": 97282,
	"./logo-dvpn.svg": 71889,
	"./logo-ele.svg": 89849,
	"./logo-eth.axl.svg": 97853,
	"./logo-flix.svg": 39274,
	"./logo-glto.svg": 48961,
	"./logo-grav.svg": 42455,
	"./logo-grvt8.svg": 81713,
	"./logo-inj.svg": 5604,
	"./logo-ist.svg": 37795,
	"./logo-jkl.svg": 91555,
	"./logo-juno.svg": 79039,
	"./logo-lse.svg": 62136,
	"./logo-lvn.svg": 11230,
	"./logo-mpwr.svg": 96607,
	"./logo-nibi.svg": 44348,
	"./logo-noimage.svg": 93639,
	"./logo-ntrn.svg": 70129,
	"./logo-osmo.svg": 77255,
	"./logo-pasg.svg": 70699,
	"./logo-pbb.svg": 79710,
	"./logo-plq.svg": 23432,
	"./logo-qwoyn.svg": 20294,
	"./logo-rock.svg": 48813,
	"./logo-sarch.svg": 57234,
	"./logo-sei.svg": 41778,
	"./logo-shd.svg": 85137,
	"./logo-spice.svg": 36723,
	"./logo-stkosmo.svg": 82049,
	"./logo-stnibi.svg": 74477,
	"./logo-test.svg": 62566,
	"./logo-usdc.axl.svg": 53894,
	"./logo-usdc.axv.svg": 8466,
	"./logo-usdc.grav.svg": 18279,
	"./logo-usdc.nobl.svg": 72244,
	"./logo-usdc.svg": 16553,
	"./logo-usdt.axv.svg": 1771,
	"./logo-usdt.grav.svg": 89302,
	"./logo-usdt.svg": 58826,
	"./logo-vdl.svg": 75459,
	"./logo-wbtc.axl.svg": 31633,
	"./logo-xakt.svg": 15377,
	"./logo-xamatom.svg": 66640,
	"./logo-xarch.svg": 32313,
	"./logo-xatom.svg": 34495,
	"./logo-xaxl.svg": 29828,
	"./logo-xbcna.svg": 68014,
	"./logo-xbld.svg": 69062,
	"./logo-xbtsg.svg": 14275,
	"./logo-xcmdx.svg": 35299,
	"./logo-xconst.svg": 16389,
	"./logo-xcore.svg": 32109,
	"./logo-xcudos.svg": 62295,
	"./logo-xdec.svg": 94033,
	"./logo-xdvpn.svg": 1299,
	"./logo-xflix.svg": 90950,
	"./logo-xgrav.svg": 32518,
	"./logo-xinj.svg": 67594,
	"./logo-xjkl.svg": 54395,
	"./logo-xjuno.svg": 70354,
	"./logo-xlvn.svg": 46844,
	"./logo-xmpwr.svg": 71458,
	"./logo-xnibi.svg": 34607,
	"./logo-xosmo.svg": 72884,
	"./logo-xpasg.svg": 74940,
	"./logo-xplq.svg": 53935,
	"./logo-xqwoyn.svg": 92787,
	"./logo-xusdc.svg": 47333,
	"./logo-xvdl.svg": 47062
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92523;